import { Dialog } from "@shared/ui/bits";
import { ShortcutList } from "@shared/ui/shortcut-list";

/** «Горячие клавиши» — как окно по Ctrl+/ в Discord. */
export function Shortcuts({ onClose }: { onClose: () => void }) {
  return (
    <Dialog title="Горячие клавиши" onClose={onClose}>
      <ShortcutList />
    </Dialog>
  );
}
